import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Constants } from 'src/app/models/constants';
import { QRButton } from 'src/app/models/qr-button.model';

@Component({
  selector: 'app-table-row',
  templateUrl: './table-row.component.html',
  styleUrls: ['./table-row.component.scss']
})
export class TableRowComponent implements OnInit {

  @Input() data:any;
  @Output() checkChange: EventEmitter<any> = new EventEmitter();
  @Output() byAction: EventEmitter<any> = new EventEmitter();

  kebabButtonConfig: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_SMALL,
    icon: Constants.ICONS.KEBAB,
    iconOnly: true,
  };

  icon:{name:string, color:string} = {name:'',color:''};
  tooltip:string = '';

  checked = false

  ngOnInit(): void {
  if(this.data) {
    this.generateIconEstado();
  }

  }

  generateIconEstado() {
    switch (this.data.estado) {
      case 'W':
        this.icon.name = 'waiting-blue';
        this.icon.color = 'primary-500';
        this.data.cae = 'Procesando';
        this.tooltip = 'Procesando en AFIP'
        break;
        case 'A':
          this.icon.name = 'check';
          this.icon.color = 'success-700';
          this.tooltip = 'CAE generado correctamente'
          break;
          case 'E':
            this.icon.name = 'alert-orange';
            this.icon.color = 'error-500';
            this.data.cae = 'Pendiente de CAE';
          if(this.data.msgErrores && this.data.msgErrores.length>0) {
            this.tooltip = this.data.msgErrores[0].msg
          }
            break;
            case 'B':
              this.icon.name = 'pending-yellow';
              this.icon.color = 'warning-500';
              this.data.cae = 'Pendiente de CAE';
              this.tooltip = 'Factura guardada en borrador'
              break;
      default:
        this.icon.name = 'waiting-blue';
        this.icon.color = 'primary-500';        
        break;
    }

  }

  checkboxChange(event:boolean) {
    const dto = {
      checked: event,
      id: this.data.cbteId
    }
    this.checkChange.emit(dto);
  }

  onActionMenu(action:string) {
    const dto = {
      action:action,
      id: this.data.cbteId
    }
    this.byAction.emit(dto);
  }
}
